import { render, staticRenderFns } from "./BillingAddress.vue?vue&type=template&id=4d5f52d6&"
import script from "./BillingAddress.vue?vue&type=script&lang=ts&"
export * from "./BillingAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports